var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-411 -1458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_1",
    transform: "translate(414 1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C17.9086094 80 0 62.0913906 0 40 0 17.9086094 17.9086094 0 40 0 62.0913906 0 80 17.9086094 80 40 80 62.0913906 62.0913906 80 40 80zM28 52L52 28",
    id: "Vector",
    stroke: "#FCBB00",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FCBB00",
    cx: 28,
    cy: 28,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FCBB00",
    cx: 50.667,
    cy: 50.667,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo1);
export default __webpack_public_path__ + "static/media/v_lo_1.3c51647f19d17ad723d152cf07571c2d.svg";
export { ForwardRef as ReactComponent };